var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.carregando == true)?_c('div',{staticClass:"carregando"},[_c('img',{attrs:{"width":"130px","src":_vm.iconeCarregando}}),_c('br'),_c('br'),_vm._v("Carregando...\n  ")]):_vm._e(),_c('VCreditCard',{attrs:{"trans":_vm.translations},on:{"change":_vm.creditInfoChanged}}),_c('div',{staticClass:"text-center"},[_c('n-button',{staticClass:"btn-degrade",attrs:{"disabled":_vm.carregando,"type":"success"},on:{"click":_vm.adicionar}},[_vm._v(_vm._s(_vm.carregando
          ? 'Carregando...'
          : _vm.textoBotao
          ? _vm.textoBotao
          : 'Adicionar Cartão'))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }